import React, { Component } from 'react';
import moment from 'moment';
import { animateScroll } from 'react-scroll';
import ConfirmationField from 'components/ConfirmationField';
import i18n from 'utils/translate';
import NavigationButtons from 'components/NavigationButtons';
import Section from 'components/Section';
import PaymentConfirmation from 'components/PaymentConfirmation';
import '../../constants';
import { formatPrice } from 'utils/common';
import loader from '../../../../../images/loader-big.gif';
import './styles.scss';
import {
  PAYMENT_SEPA,
  PAYMENT_TYPE_ANNUAL,
  PAYMENT_TYPE_BIANNUAL,
  PAYMENT_TYPE_MONTHLY,
  PAYMENT_TYPE_QUARTERLY
} from '../../constants';
import { calculateEndDate, paymentDetails } from '../../utils';

class Confirmation extends Component {
  state = {
    blockConfirmClick: false
  };

  componentDidMount() {
    const { onRender } = this.props;

    if (onRender) {
      onRender();
    }

    animateScroll.scrollToTop({ duration: 0 });
  }

  onClick = () => {
    this.setState({
      blockConfirmClick: true
    });

    window.dataLayer.push({
      event: 'onlineabschluss',
      formname: 'Fahrraddiebstahl-Versicherung',
      action: 'Schritt 4 von 4'
    });
  };

  render() {
    const {
      markeModell,
      kaufpreis = 0,
      ebike,
      anrede,
      vorname,
      nachname,
      geburtsdatum,
      strasse,
      nr,
      plz,
      ort,
      land = i18n('Österreich'),
      telefon,
      email,
      payment_type,
      iban,
      bic,
      promotion,
      vermittler,
      onConfirm,
      loading,
      backLink,
      quote,
      baujahr,
      versicherungsbeginn,
      rahmennummer,
      apiErrorMessages,
      paymentPending,
      zahlungsweise
    } = this.props;

    if (paymentPending) {
      return (
        <div className="bike-confirmation loader-wrapper">
          <img src={loader} alt="loader" />
        </div>
      );
    }

    const paymentProps = { type: payment_type, iban, bic };

    let paymentTypeDisplayName;

    if (payment_type === PAYMENT_SEPA) {
      paymentTypeDisplayName = i18n('jährlich');
      if (zahlungsweise === PAYMENT_TYPE_BIANNUAL) {
        paymentTypeDisplayName = i18n('halbjährlich');
      } else if (zahlungsweise === PAYMENT_TYPE_QUARTERLY) {
        paymentTypeDisplayName = i18n('vierteljährlich');
      } else if (zahlungsweise === PAYMENT_TYPE_MONTHLY) {
        paymentTypeDisplayName = i18n('monatlich');
      }
    }

    let finalPrice = null;
    let currency = null;
    let paymentVariants = null;

    if (!!quote) {
      finalPrice = quote.price;
      currency = quote.currency;
      paymentVariants = quote.paymentVariants;
    }

    const endDate = calculateEndDate(versicherungsbeginn);

    return (
      <div className="page-step-wrapper page-step-wrapper--narrow bike-confirmation" id="confirmation-wrapper">
        {/* --- Insurance --- */}
        <Section header={i18n('Versicherung')}>
          <ConfirmationField title={i18n('Marke und Modell')}>{markeModell}</ConfirmationField>
          <ConfirmationField title={i18n('E-Bike')}>{ebike ? i18n('Ja') : i18n('Nein')}</ConfirmationField>
          <ConfirmationField title={i18n('Neupreis inkl. Zubehör')}>
            {formatPrice(kaufpreis, quote.currency)}
          </ConfirmationField>
          <ConfirmationField title={i18n('Baujahr')}>{baujahr.format('YYYY')}</ConfirmationField>
          <ConfirmationField title={i18n('Rahmennummer')}>{rahmennummer}</ConfirmationField>
          <ConfirmationField title={i18n('Versicherungsbeginn')}>
            {versicherungsbeginn.format('DD.MM.YYYY')}
          </ConfirmationField>
          <ConfirmationField title={i18n('Versicherungsende/Folgefälligkeit')}>{endDate}</ConfirmationField>
        </Section>

        {/* --- Personal Data --- */}
        <Section header={i18n('Persönliche Angaben')}>
          <ConfirmationField title={i18n('Name')}>{`${
            anrede === 0 ? i18n('Herr') : i18n('Frau')
          } ${vorname} ${nachname}`}</ConfirmationField>
          <ConfirmationField title={i18n('Geburtsdatum')}>
            {moment(geburtsdatum).format('DD. MMMM YYYY')}
          </ConfirmationField>
        </Section>

        {/* --- Address --- */}
        <Section header={i18n('Wohnadresse')}>
          <ConfirmationField title={null}>{`${strasse} ${nr}`}</ConfirmationField>
          <ConfirmationField title={null}>{`${plz} ${ort}`}</ConfirmationField>
          <ConfirmationField title={null}>{`${land}`}</ConfirmationField>
        </Section>

        {/* --- Contact --- */}
        <Section header={i18n('Kontakt')}>
          <ConfirmationField title={i18n('Telefon')}>{telefon}</ConfirmationField>
          <ConfirmationField title={i18n('E-Mail')}>{email}</ConfirmationField>
        </Section>

        {/* --- Miscellaneous --- */}
        {vermittler && (
          <Section header={i18n('Sonstiges')}>
            {vermittler && <ConfirmationField title={i18n('Vermittler-Nummer')}>{vermittler}</ConfirmationField>}
          </Section>
        )}

        {/* --- Payment Information --- */}
        <Section header={i18n('Bezahlung')}>
          <PaymentConfirmation {...paymentProps} />
          {payment_type === PAYMENT_SEPA && (
            <ConfirmationField title={i18n('Zahlungsweise')}>{paymentTypeDisplayName}</ConfirmationField>
          )}
          {apiErrorMessages &&
            apiErrorMessages.length > 0 &&
            apiErrorMessages.map((error, index) => (
              <span className="error-message col-xs-12" key={`error-${index}`}>
                <span className="error-icon" />
                {error.validierungsText}
              </span>
            ))}
        </Section>

        {/* --- Additional Information --- */}
        <Section header={i18n('Vertragsabschluss')}>
          <ConfirmationField title={i18n('Kontaktaufnahme zu Werbezwecken')} halfWidth={false} broadTitle={false}>
            {promotion ? i18n('Ja') : i18n('Nein')}
          </ConfirmationField>
        </Section>

        <div className="row">
          <div className="col-xs-12 info-text">
            <p>
              Nach Vertragsabschluss (durch Klick auf den Button „Online abschließen“) erhalten Sie ein
              Bestätigungs-E-Mail über den Vertragsabschluss an die von Ihnen angegebene E-Mail- Adresse.
            </p>
            <p>
              An einem der darauffolgenden Arbeitstage erhalten Sie Ihre Versicherungspolizze an die von Ihnen
              angegebene Postadresse.
            </p>
          </div>
        </div>

        <div className="sticky-footer">
          <div className="page-step-wrapper__price">
            {i18n('Prämie (jährlich)')}&nbsp;
            {quote && formatPrice(finalPrice, currency)}
            {zahlungsweise !== PAYMENT_TYPE_ANNUAL && !!paymentVariants && paymentDetails(zahlungsweise, quote)}
          </div>
          <NavigationButtons
            backLink={backLink}
            nextLink={{ go: onConfirm }}
            nextText={i18n('Online abschließen')}
            loading={loading}
            onClick={this.onClick}
          />
        </div>
      </div>
    );
  }
}

export default Confirmation;
